<template>
  <div>
    <b-modal
      :hide-header="false"
      :hide-footer="true"
      content-class="modal-blue"
      id="first-friend-conversation-chat-modal"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="false"
      @shown="onModalShown"
       
      
      size="lg">
      <!-- Modal content -->
 
        
     <div class="overflow-auto" style="height: 420px;" v-if="allMessages.length>0" ref="myDiv">
 

      <div class="d-flex  mb-3" :class="allMessage.userType=='student'?'justify-content-end':'justify-content-start'" v-for="allMessage of allMessages">
        <div :class="allMessage.userType=='student'?'bg-danger':'bg-primary'" class="  rounded-pill p-4 px-3" style="max-width: 75%;">
             <small class="d-block text-white" :class="allMessage.userType=='student'?'text-right':'text-left'" style="font-size:10px"> {{ allMessage.userType=='student'?allMessage.stud:allMessage.fname+' '+allMessage.lname }}   </small>
          {{ allMessage.message }}
          <small class="d-block text-white" :class="allMessage.userType=='student'?'text-right':'text-left'" style="font-size:10px">    {{ allMessage.put_date }}</small>
        </div>
      </div>

    

       </div>

    <!-- Input -->
    <div class="card-footer bg-white" v-if="currentStatusID==1">
      <div class="d-flex">
        <textarea class="form-control mr-2" rows="1" placeholder="ჩაწერეთ შეტყობინება" v-model="messages" @keydown.enter="sendChatMessage()"></textarea>
        <button class="btn btn-danger" @click="sendChatMessage()" >გაგზავნა</button>
      </div>
    </div>
  


            
       
       



    </b-modal>

  </div>
</template>

<script>
 import firstFriendResource from '../../api/firstFriendResource';
 const firstFriendResourceObj=new firstFriendResource()

export default {

    


    props:['conversationID','currentStatusID'],
    data(){
        return{
            messages:null,
            allMessages:[],
           
             
        }

    },


            methods:{


                scrollToBottom() {
                   this.$nextTick(() => {
                    const div = this.$refs.myDiv;
                   if (div) div.scrollTop = div.scrollHeight;
                    });
                 },

                onModalShown(){ 


                     firstFriendResourceObj.setAllRead(this.conversationID).then(()=>{

                            this.$emit('read-event',this.conversationID)

                     })




                      this.getAllMessage() 


                },


                getAllMessage(){

                    firstFriendResourceObj.getAllMessages(this.conversationID).then(response=>{

                            this.allMessages=response.data
                            setTimeout(()=>{
                                this.scrollToBottom()
                            },30)
                             

                      })  

                },

                sendChatMessage(){

                    if(this.messages){

                    firstFriendResourceObj.sendChatMessage(this.conversationID,this.messages).then(()=>{

                            
                            this.getAllMessage() 
                            this.messages=null
                            

                    })
                    }else {
                        alert("ჩაწერეთ შეტობინება")
                    }
                }


            }


   
};
</script>

<style scoped>
 

</style>
 